const messages = {
    bonus: {
        title: "Aperçu des crédits bonus",
        description:
            "Des bonus en euros sont attribués aux entreprises participantes sur base des chiffres de vente soumis.",
        lastMonth: "Mois dernier",
        currentMonth: "Mois en cours",
        totalCurrentYear: "Total année en cours",
        totalLastYear: "Total année précédente",
    },
    points: {
        title: "Aperçu des crédits points",
        period: "Année civile en cours ({year})",
        totalAwarded: "Total de points attribués",
        redeemed: "Points échangés",
        totalBalance: "Solde total de points",
        redemptionRate: "Part des points attribués qui ont été échangés",
        averageAwarded: "Moyenne des points attribués par pneu acheté",
        standardAwarded: "Points nets des lignes de vente calculées, retours inclus",
        bsPlusInclBooster: "Points des lignes de vente à quantité positive",
        perTire: "Points échangés par pneu acheté",
    },
    tires: {
        title: "Aperçu du nombre de pneus",
        description: "Pneus achetés par les clients",
        prevMonth: "Volume mois précédent",
        totalLastYear: "Volume année précédente",
        purchaseIndirect: "Achats via grossiste",
        purchaseDirect: "Achats via Bridgestone",
        totalCurrentYear: "Volume année en cours",
        currentMonth: "Volume mois en cours",
    },
    participating: {
        title: "Aperçu des clients participants",
        description:
            "Les entreprises qui s’enregistrent sur BRIDGESTONE PLUS peuvent être associées par notre équipe via leur numéro client.",
        total: "Total",
        newThisMonth: "Nouveaux ce mois-ci",
        newThisYear: "Nouveaux cette année",
        createdInCurrentMonth: "Créé ce mois-ci (par un administrateur)",
        loginsCurrentYear:
            "Connexions cette année (après acceptation des CGU)",
    },
    brand: {
        title: "Marque",
        description: "Vos achats en détail",
        centerTitle: "Par\nmarque",
    },
    rim: {
        title: "Jante",
        centerTitle: "Par\ntaille de jante",
    },
    tireGoals: {
        title: "Objectifs d’achat de pneus",
        subtitle: "Gagnez des points pour vos achats de pneus.",
        centerTitle: "Par\ntaille de pneu",
        tiresRemaining: "Pneus restants",
        progressionTarget: "Progression campagne performance : ",
        performanceGoalProgress: "Progression campagne performance",
        campaignPeriod: "Période campagne",
        pointsEarnedPurchases:
            "points gagnés\n" + "grâce à vos\n" + "achats",
        pointsEarnedBoosters:
            "points gagnés\n" + "grâce aux\n" + "boosters",
        purchasesDetail: "Détails de vos achats",
        cta: "En savoir plus sur vos points.",
        pointsTitle: "Vos points",
        pointsSubtitle: "Points gagnés sur vos achats Bridgestone",
        achievementsTitle: "Vos réussites",
        achievementsSubtitle: "Engagement campagne performance :",
        achievementsSubtitle2: "pneus",
    },
    score: {
        title: "Statut points au",
        total: "Total points",
        totalPoints: "Total points",
        credits: "Crédits en",
        deductions: "Déductions en",
        unlockedPoints: "Points débloqués",
        pendingPoints: "Points en attente",
    },
    dealerPerformance: {
        title: "Performance",
        performanceAnnualEngagement: "Engagement campagne performance",
        performanceVolumeToDate: "Volume campagne performance",
        performanceCampaignPeriod: "Période campagne",
        boosterCcsParticipant: "Participant Booster CCS",
    },
    boosterCcs: {
        title: "Animation Booster CCS",
        historyTitle: "Animation Booster CCS",
        historyDescription: "Tous vos résultats Booster CCS par période.",
        seeMore: "Voir plus",
        empty: "Aucun résultat Booster CCS disponible.",
        exploreResults: "Découvrez vos résultats",
        learnMechanics: "En savoir plus sur la mécanique",
        yourRealisation: "Vos réalisations",
        yourPoints: "Vos points",
        soldTyres: "Pneus vendus",
        receivedPoints: "Points gagnés",
        pointsBySales: "Points générés par vos ventes de pneumatiques Bridgestone",
        salesDetail: "Vos ventes en détail",
        tyreLimitInfo:
            "Un volume sell-out de minimum 50 pneumatiques des marques Bridgestone et/ou Firestone est requis pour chaque période de l’animation Booster",
        noSalesBreakdown: "Pas encore de détail des ventes pour cette période.",
        charts: {
            byBrand: "Par marque",
            bySize: "Par taille<br/>de jante",
        },
    },
    score_extended: {
        title1: "Solde de points",
        title2: "Bonus en euros",
        balance: "Solde de points",
        bonus_in_euro: "Bonus en euros",
        date: "Date",
        added_points: "Points ajoutés en",
        total_bands: "Total des paliers",
        goal: "Objectif",
        tyres_previous_year: "Pneus vendus l’an dernier",
        tyres_current_year: "Pneus vendus cette année",
        target_this_year: "Objectif de ventes cette année",
        bonus_this_year: "Bonus gagné (€)",
        loyal_minimum: "Niveau minimum de fidélité",
        bonus_multiplier: "Taux multiplicateur de bonus",
    },
    lastImport: {
        label: "Dernier import des chiffres de vente :",
        on: "le",
    },
    wholesalerTable: {
        title: "Clients participants en détail",
        description:
            "Vous trouverez ci-dessous les entreprises enregistrées sur BRIDGESTONE PLUS avec le numéro client de votre société. " +
            "Vous pouvez utiliser les filtres pour un tri différent ou la fonction de recherche pour retrouver un client.",
        downloadButton: "Téléchargements",
        columns: {
            customer_number: "N° client",
            address_company_name: "Entreprise",
            address_street: "Rue et numéro",
            address_postal_code: "Code postal",
            address_city: "Ville",
            last_registration: "Dernière inscription",
            network: "Réseau",
            profile_group: "Groupe",
            tires_amount: "Nombre de pneus",
            point_balance: "Solde de points",
            bonus: "Bonus",
            details: "Détails",
        },
        searchPlaceholder: "Rechercher",
    },
    dealerTable: {
        columns: {
            date: "Date",
            wholesaler_bs_plus: "Grossiste BS+",
            customer_number: "Numéro client",
            article: "Article",
            brand: "Marque",
            product: "Produit",
            type: "Type",
            inch: "Pouces",
            season: "Saison",
            amount: "Quantité",
            points: "Points",
            activity: "Activité",
            total_points: "Total des points",
        },
        title: "Tableau des revendeurs",
        description: "Aperçu des activités des revendeurs",
    },
    business_units: {
        title: "Profils utilisateurs",
        centerTitle: "Par\nunité",
    },
    season: {
        title: "Saison",
        centerTitle: "Par\npériode de l’année",
    },
};

export default {
    messages,
};
